@if (settings) {
  <div style="color: #1F1F1F; font-size: 20px; padding: 40px;">
    @if (settings.trustReportLogo) {
      <div style="float: right; ">
        <img style="max-width: 300px; max-height: 300px;"
          [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(settings.trustReportLogo) + '&asImage=true&tenantName=' + tenantName" />
      </div>
    }
    <div>
      <h1
        style="color: #6F6F6F; font-size: 30px; font-weight: bold; margin-bottom: 55px;">{{ settings.trustReportCompanyName }}
        Trust Information</h1>
    </div>
    <div>
      <label style="color: #7A7A7A; font-size: 20px; margin-bottom: 42px;">
        Authorized Product Name:&nbsp;
      </label>
      <span>{{ settings.trustReportProductName }}</span>
    </div>
    <div style="margin-bottom: 58px;">
      <label style="color: #7A7A7A; font-size: 20px; margin-bottom: 28px;">
        Description of Services:
      </label>
      <div [innerHTML]="settings.trustReportDescription | sanitizeHtml"></div>
    </div>
    <div style="margin-bottom: 58px;">
      <label style="color: #7A7A7A; font-size: 20px;">
        Authorization Page:&nbsp;
      </label>
      <a style="color: #2D73C9;" target="_blank"
         [attr.href]="settings.trustReportListingLink">{{ settings.trustReportListingLink }}</a>
    </div>
    <div>
      <label style="color: #7A7A7A; font-size: 20px; margin-bottom: 28px;">
        Instructions for Accessing Trust Information:
      </label>
      <div [innerHTML]="settings.trustReportInstructions | sanitizeHtml"></div>
    </div>
  </div>
}
